import { createTheme, ThemeProvider } from "@mui/material";
import { configureStore } from "@reduxjs/toolkit";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import LoginManager from "./LoginManager";
import Reducer from "./redux/reducers/reducer";

const store = configureStore({ reducer: { Reducer: Reducer } });

const theme = createTheme({
  status: {
    danger: "red",
  },
  // Your theme configuration
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <LoginManager />
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);
